import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Sidebar from "./Components/Sidebar";
import ProtectedRoute from "./Components/ProtectedRoute";
import Dashboard from "./Pages/Dashboard/Dashboard";
// import RegisterLogin from "./Pages/RegisterLogin/RegisterLogin.jsx"
import Login from "./Pages/Login/Login.jsx";
import CreateAdmin from "./Pages/CreateAdmin/CreateAdmin.jsx";
import UpdateItem from "./Pages/UpdateItem/UpdateItem.jsx";
import CreateItem from "./Pages/CreateItem/CreateItem.jsx";
import Order from "./Pages/Order/Order.jsx";
import CreatePlatter from "./Pages/CreatePlatter/CreatePlatter.jsx";

function App() {
  const role = localStorage.getItem("role")
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public route: Login */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes (including Sidebar) */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div className="flex h-screen">
                  {/* Sidebar (only for authenticated users) */}
                  <Sidebar />

                  {/* Main Content */}
                  <div className="flex-1 overflow-auto p-4">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      {role === "super_admin" && <Route path="create-admin" element={<CreateAdmin />} />}
                      <Route path="/create-item" element={<CreateItem />} />
                      <Route path="/update-item" element={<UpdateItem />} />
                      <Route path="/create-platter" element={<CreatePlatter />} />
                      <Route path="/update-platter" element={<UpdateItem />} />
                      <Route path="/orders" element={<Order />} />
                      {/* <Route path="/delete-item" element={<h2>Delete Item (Coming Soon)</h2>} /> */}
                      {/* Redirect any unmatched routes */}
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
